module.exports = __webpack_public_path__ + "static/WEDDING E&M-575-bac91102c33f65331199f47ba3942208.jpg";